"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePost = exports.getPostListAll = exports.deletePostById = exports.deleteBatchPostById = exports.addPost = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
/**
 * 添加岗位表
 * @param post
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var addPost = exports.addPost = function addPost(post) {
  return _api.default.request({
    url: '/system/post/save',
    method: 'post',
    data: post
  });
};

/**
 * 修改岗位表
 * @param post
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var updatePost = exports.updatePost = function updatePost(post) {
  return _api.default.request({
    url: '/system/post/update',
    method: 'post',
    data: post
  });
};

/**
 * 删除岗位表
 * @param postId
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var deletePostById = exports.deletePostById = function deletePostById(postId) {
  return _api.default.request({
    url: '/system/post/delete',
    method: 'post',
    params: {
      id: postId
    }
  });
};

/**
 * 批量删除岗位表
 * @param postIds
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var deleteBatchPostById = exports.deleteBatchPostById = function deleteBatchPostById(postIds) {
  return _api.default.request({
    url: '/system/post/deleteBatch',
    method: 'post',
    data: postIds
  });
};

/**
 * 获取所有数据
 * @returns {AxiosPromise}
 */
var getPostListAll = exports.getPostListAll = function getPostListAll() {
  return _api.default.request({
    url: '/system/post/all',
    method: 'get'
  });
};